import { InjectionToken } from '@angular/core';

import { ICommunicationContext } from 'shared-business/communication';

import { ILocalStorageService } from './services/local-storage.service';
import { ISaveFileService } from './services/save-file.service';
import { IShutdownService } from './services/shutdown.service';

export const SAVE_FILE_SERVICE: InjectionToken<ISaveFileService> = new InjectionToken<ISaveFileService>('SAVE_FILE_SERVICE');
export const DPU_SERVICE: InjectionToken<ICommunicationContext> = new InjectionToken<ICommunicationContext>('DPU_SERVICE');
export const LAST_SETUP_FILE_PATH_STORAGE_KEY: InjectionToken<string> = new InjectionToken<string>('LAST_SETUP_FILE_PATH_STORAGE_KEY');
export const LAST_SETUP_FILE_NAME_STORAGE_KEY: InjectionToken<string> = new InjectionToken<string>('LAST_SETUP_FILE_NAME_STORAGE_KEY');
export const LOCAL_STORAGE_SERVICE: InjectionToken<ILocalStorageService> = new InjectionToken<ILocalStorageService>('LOCAL_STORAGE_SERVICE');
export const SHUTDOWN_SERVICE: InjectionToken<IShutdownService> = new InjectionToken<IShutdownService>('SHUTDOWN_SERVICE');
